module.exports = __webpack_public_path__ + "media/tile-2-image.284c9276.png";